import type {IUnlimTariff} from "~/components/sx/prices/PricesUnlimItem.vue";

export interface IPromiseTariff {
  id: number,
  title: string,
  discount: string,
  is_default: boolean,
  price: number,
  price_corporate: number,
  price_mobile: number,
  price_residential: number,
  description: string,
  duration_days: 30,
  traffic: 30,
  type: 30,
  types: { name: string, price: number }[]
}

export const useCustomTariffStore = () => {
  const { apiService } = useApi();

  const tariffs = useState('tariffs', () => {
    return {
      promise: [] as IPromiseTariff[],
      unlim: [] as IUnlimTariff[],
    }
  })

  function extractDiscount(text: string): number | null {
    const match = text.match(/(\d+)\s*%/);
    return match ? parseInt(match[1], 10) : null;
  }

  async function getPromiseTariffs() {
    try {
      if (!tariffs.value.promise.length) {
        const resp = await apiService.get('tariff/promise');
        tariffs.value.promise = resp.data.map((e: IPromiseTariff) => {
          return {
            ...e,
            discount: extractDiscount(e.description) + '%',
            price: Math.trunc((e.price)),
            types: [
              { name: 'pages.home.types.mobile.name', price: e.price_mobile },
              { name: 'pages.home.types.resident.name', price: e.price_residential },
              { name: 'pages.home.types.corporate.name', price: e.price_corporate },
            ],
          }
        });
      }
    }
    catch (err: any) {
      console.error(err.message);
    }
  }

  async function getUnlimTariffs() {
    try {
      if (!tariffs.value.unlim.length) {
        const resp = await apiService.get('tariff/pack');
        tariffs.value.unlim = resp.data;
      }
    }
    catch (err: any) {
      console.error(err.message);
    }
  }

  return {
    tariffs,
    getPromiseTariffs,
    getUnlimTariffs,
  }
}